import { UCCLookUpParams, UCCLookupTypes } from '..'
import { HttpServiceResponse } from '../../shared'
import AbstractProvider from '../../shared/abstract.provider'

export class UCCLookUpProvider extends AbstractProvider {
  urlPath = 'ucc_lookups_api'

  public lookup<T>(action: UCCLookupTypes, params: UCCLookUpParams): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      action,
      ...params,
    })

    return this.http.post(`${this.url}?${query}`)
  }
}
